// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import { TrackingTrigger, TrackingProvider } from '@indeed/flex-tracking-context'

import PageView from 'syft-acp-core/components/PageView'
import WorkerStrikeDetails from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails'
import { SAVE_BUTTON_EVENT } from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails/WorkerStrikeDetails.helpers'
import { WorkerSubNavigation } from './SubNavigation'
import { trackingEvents } from './EntityWorkersStrikesNew.tracking'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{
  id: string
}>

export const EntityWorkersStrikesNew = ({ match: { params } }: Props) => (
  <TrackingProvider
    value={{
      context: {
        worker_id: params.id,
      },
      eventMappings: event => (event === SAVE_BUTTON_EVENT ? trackingEvents.SAVE_BUTTON.CLICKED : event),
    }}
  >
    <TrackingTrigger onLoad={{ event: trackingEvents.PAGE.VIEWED }} />
    <WorkerSubNavigation workerID={params.id} />
    <PageView title={[`New strike for worker ${params.id}`]}>
      <WorkerStrikeDetails workerID={Number(params.id)} id={0} />
    </PageView>
  </TrackingProvider>
)
